import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { useThemeSettings } from '../../../../contexts/ThemeContext';
import { SolutionRecommendation } from '../../../../components/Tickets/SolutionRecommendation';

/**
 * Ticket content section with description and steps tried
 */
const TicketContent = ({
  ticket,
  isSupport,
  onSolutionSelect
}) => {
  const { t } = useThemeSettings();

  return (
    <Paper sx={{ p: 3, mb: 3 }}>
      {/* Title */}
      <Typography variant="h5" component="h2" gutterBottom>
        {ticket.title || 'No title provided'}
      </Typography>

      {/* Description */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          {t ? t("LocationDialog.description") : "Description"}
        </Typography>
        <Typography variant="body1" paragraph sx={{ whiteSpace: 'pre-wrap' }}>
          {ticket.description || 'No description provided'}
        </Typography>
      </Box>

      {/* Steps Tried */}
      {ticket.steps_tried && (
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            {t ? t("VisualTreeView.steps_already_tried") : "Steps Already Tried"}
          </Typography>
          <Typography variant="body1" paragraph sx={{ whiteSpace: 'pre-wrap' }}>
            {ticket.steps_tried}
          </Typography>
        </Box>
      )}

      {/* Solution Recommendations - Show to support staff */}
      {isSupport && ticket.description && (
        <Box sx={{ mb: 3 }}>
          <SolutionRecommendation
            ticketDescription={ticket.description}
            isSupport={isSupport}
            onSolutionSelect={onSolutionSelect}
          />
        </Box>
      )}
    </Paper>
  );
};

export default TicketContent;
